import {MANIFEST_POST_ADD_DOC} from "../axios";

export const axiosPostAddNewMan = async (axiosPrivate, body, getRequestDataToggle, getIdCreateDoc, cargoCaseId, setErrorMessage, setActiveCreateManModal) => {
    try {
        const response = await axiosPrivate.post(MANIFEST_POST_ADD_DOC,
            JSON.stringify(body))
        let promise = new Promise((resolve, reject) => {
            resolve(response)
        })
        promise.then(
            function (response) {
                getRequestDataToggle()
                return new Promise((resolve, reject) => {
                    resolve(response)
                })
            }).then(
            function (response) {
                getIdCreateDoc(cargoCaseId)
            }).catch(
            function (error) {
                console.log(error)
            })
        setErrorMessage('');
        setActiveCreateManModal(false);
    } catch (err) {
        setErrorMessage('Error creating document, please try again!');
        setActiveCreateManModal(false);
        console.error(err);
    }
}

